import FormBuilder from './FormBuilder';
import FormField from './FormField';
import FormFieldList from './FormFieldList';

export const components = {
	FormBuilder,
	FormField,
	FormFieldList
};
